import { Component, inject } from '@angular/core';
import { ENV, Env, MarketingLinks, marketingLinks } from '@bodyanalytics/app-config';

@Component({
  standalone: true,
  selector: 'bodyanalytics-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly appConfig = inject<Env>(ENV);

  /** Environment-aware marketing destinations (dev vs prod). */
  protected readonly marketing: MarketingLinks = marketingLinks(this.appConfig);
}
